import { Bookmark } from "lucide-react";

interface ColorVariant {
  name: string;
  color: string;
}

interface CompanionCardProps {
  title: string;
  price?: string;
  variants?: ColorVariant[];
  extraVariants?: number;
  comingSoon?: boolean;
  description?: string;
  image?: string;
  srcSet?: string;
}

const CompanionCard = ({
  title,
  price,
  variants = [],
  extraVariants = 0,
  comingSoon = false,
  description,
  image,
  srcSet,
}: CompanionCardProps) => {

  return (
    <div className="group select-none">
      <div className="relative aspect-square media-placeholder overflow-hidden">
        {image ? (
          <img
            src={image}
            srcSet={srcSet}
            sizes="(max-width: 749px) 88vw, (max-width: 1280px) 30vw, 426px"
            alt={title}
            loading="lazy"
            decoding="async"
            width={600}
            height={600}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full media-placeholder" />
        )}
      </div>

      <h3 className="product-item__title companion-card__title text-foreground text-center mt-4 mb-1.5 leading-snug">
        {title}
      </h3>

      {comingSoon && description && (
        <p className="body-small text-muted-foreground text-center mt-1 mb-2 line-clamp-2">
          {description}
        </p>
      )}

      <div className="product-information">
        {comingSoon ? (
          <p className="price text-secondary-foreground text-center">
            Coming Soon
          </p>
        ) : (
          <p className="price text-secondary-foreground text-center">
            {price}
          </p>
        )}
      </div>

      {!comingSoon && variants.length > 0 && (
        <div className="flex items-center justify-center gap-2 mt-3">
          {variants.map((v) => (
            <span
              key={v.name}
              className="w-5 h-5 border border-border/60"
              style={{ backgroundColor: v.color }}
              title={v.name}
            />
          ))}
          {extraVariants > 0 && (
            <span className="text-meta text-muted-foreground">
              +{extraVariants}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanionCard;